"use client";

import { Sparkles } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";

import ConditionalTakeQuizButtonContainer from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/conditional-take-quiz-button.container";
import { type ViewMode } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/constants";
import SearchFiltersDrawerContainer from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/search-filters-drawer.container";
import { ViewModeToggle } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/view-mode-toggle";
import { Button } from "@/components/ui/button";
import routes from "@/lib/routes";

interface MobileActionBarViewProps {
  viewMode: ViewMode;
  getModeUrl: (mode: ViewMode) => string;
  alertsSlot: ReactNode;
}

export function MobileActionBarView({
  viewMode,
  getModeUrl,
  alertsSlot,
}: MobileActionBarViewProps): ReactNode {
  return (
    <div className="lg:hidden bg-card border-b border-border px-4 py-2">
      <div className="flex items-center gap-2">
        <ConditionalTakeQuizButtonContainer
          button={
            <Button
              asChild
              className="flex-1 bg-gradient-to-r from-accent-purple to-info hover:from-accent-purple-hover hover:to-info-hover text-primary-foreground font-medium h-8 text-xs shadow-sm"
            >
              <Link href={routes.getProfileQuiz()}>
                <Sparkles className="h-3.5 w-3.5 mr-1.5" />
                <span className="hidden sm:inline">Take Quiz</span>
                <span className="sm:hidden">Quiz</span>
              </Link>
            </Button>
          }
        />

        <div className="flex items-center gap-1.5 ml-auto">
          <ViewModeToggle viewMode={viewMode} getModeUrl={getModeUrl} />
          <SearchFiltersDrawerContainer />
          {alertsSlot}
        </div>
      </div>
    </div>
  );
}
